import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import BlockHeader from 'components/common/BlockHeader';
import SubHeading from 'components/common/SubHeading';
import Image from 'components/common/Image';
import i18n from 'i18n';
import imgHowToWebIllust1PC1x from 'assets/images/PC/@1x/img_howto_web_illust1.png';
import imgHowToWebIllust1PC2x from 'assets/images/PC/@2x/img_howto_web_illust1@2x.png';
import imgHowToWebIllust1SP2x from 'assets/images/SP/@2x/img_howto_web_illust1_1@2x.png';
import imgHowToWebIllust1SP3x from 'assets/images/SP/@3x/img_howto_web_illust1_1@3x.png';
import imgHowToWebIllust2PC1x from 'assets/images/PC/@1x/img_howto_web_illust2.png';
import imgHowToWebIllust2PC2x from 'assets/images/PC/@2x/img_howto_web_illust2@2x.png';
import imgHowToWebIllust2SP2x from 'assets/images/SP/@2x/img_howto_web_illust2_1@2x.png';
import imgHowToWebIllust2SP3x from 'assets/images/SP/@3x/img_howto_web_illust2_1@3x.png';
import imgHowToWebIllust3PC1x from 'assets/images/PC/@1x/img_howto_illust3.png';
import imgHowToWebIllust3PC2x from 'assets/images/PC/@2x/img_howto_illust3@2x.png';
import imgHowToWebIllust3SP2x from 'assets/images/SP/@2x/img_howto_illust3_1@2x.png';
import imgHowToWebIllust3SP3x from 'assets/images/SP/@3x/img_howto_illust3_1@3x.png';
import imgHowToImagePC1x from 'assets/images/PC/@1x/img_howto_image.png';
import imgHowToImagePC2x from 'assets/images/PC/@2x/img_howto_image@2x.png';
import imgHowToImageSP2x from 'assets/images/SP/@2x/img_howto_image@2x.png';
import imgHowToImageSP3x from 'assets/images/SP/@3x/img_howto_image@3x.png';
import Steps from './Steps';

const steps = [
  {
    img: {
      pc1x: imgHowToWebIllust1PC1x,
      pc2x: imgHowToWebIllust1PC2x,
      sp2x: imgHowToWebIllust1SP2x,
      sp3x: imgHowToWebIllust1SP3x,
      alt: 'img_howto_web_illust1'
    },
    p: i18n.t('about:gift.web.step1', { returnObjects: true })
  },
  {},
  {
    img: {
      pc1x: imgHowToWebIllust2PC1x,
      pc2x: imgHowToWebIllust2PC2x,
      sp2x: imgHowToWebIllust2SP2x,
      sp3x: imgHowToWebIllust2SP3x,
      alt: 'img_howto_web_illust2'
    },
    p: i18n.t('about:gift.web.step2', { returnObjects: true })
  },
  {},
  {
    img: {
      pc1x: imgHowToWebIllust3PC1x,
      pc2x: imgHowToWebIllust3PC2x,
      sp2x: imgHowToWebIllust3SP2x,
      sp3x: imgHowToWebIllust3SP3x,
      alt: 'img_howto_web_illust3'
    },
    p: i18n.t('about:gift.web.step3', { returnObjects: true })
  }
];

const Web = ({ className }) => (
  <div className={className}>
    <BlockHeader>{i18n.t('about:gift:web.header')}</BlockHeader>
    <div className="header-center">
      <SubHeading>{i18n.t('about:gift.web.description')}</SubHeading>
    </div>
    <div className="web-content">
      <Steps steps={steps} />
      <div className="example">
        <p>{i18n.t('about:gift.web.example')}</p>
        <Image
          pc1x={imgHowToImagePC1x}
          pc2x={imgHowToImagePC2x}
          sp2x={imgHowToImageSP2x}
          sp3x={imgHowToImageSP3x}
          alt="img_howto_image"
        />
      </div>
    </div>
  </div>
);

const commonStyle = css`
  .header-center {
    text-align: center;
  }

  .web-content {
    .example {
      text-align: center;

      p {
        text-align: left;
        margin: 0;
        color: ${Colors.black1};
      }

      img {
        width: 100%;
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${BlockHeader} {
    margin-top: 38px
  }

  .web-content {
    margin-top: 40px;

    .example {
      p {
        ${FontStyles.text7};
        padding: 16px 0 11px 0;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${BlockHeader} {
    margin-top: 24px
  }

  .header-center {
    h4 {
      ${FontStyles.text7};

      height: 62px;
      line-height: 22px !important;
      padding: 9px 16px;
    }
  }

  .web-content {
    margin-top: 16px;

    .example {
      p {
        ${FontStyles.text5};
        padding: 28px 0 8px 0;
      }
    }
  }
`;

export default applyStyles(Web)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Gift/components/Web.js